import { useState, Suspense, useEffect } from 'react';

const ModalItem = ({ template, param, callBackFunc, close }) => {
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    if (template) {
      const loadComponent = async () => {
        const { default: LoadedComponent } = await import(`./${template}`);
        setComponent(() => LoadedComponent);
      };
      loadComponent();
    }
  }, [template]);

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        {Component ? (
          <section className="modal show in" aria-hidden="false">
            <div className="modal-dialog">
              <Component
                modalParam={param}
                callBackFunc={callBackFunc}
                onClose={close}
              />
            </div>
            <div className="modal-back in"></div>
          </section>
        ) : null}
      </Suspense>
    </>
  );
};

export default ModalItem;
